import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      lookupFromPathIndex: 0,
    },
    lng: localStorage.getItem("i18nextLng") || "en-US",
    fallbackLng: "en-US",
    backend: {
      loadPath: (lng: any) => {
        const languageFileMap: Record<string, string> = {
          "en-us": "en-us",
          "en-ca": "en-CA",
          "en-uk": "en-uk",
          "en-fr": "en-fr",
          "es-sp": "es-SP",
        };
        const lngStr = Array.isArray(lng) ? lng[0] : (lng || "");
        const normalized = lngStr.toLowerCase();
        const mappedLng = languageFileMap[normalized] || lngStr;
        return `/translations/${mappedLng}.json`;
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
